export const monthlyMode = "monthlyMode";
export const dailyMode = "dailyMode";

export const startPosition = "startPosition";
export const middlePosition = "middlePosition";
export const endPosition = "endPosition";
